import { isDevHubClient } from '../environment/devHub';

export const DEV_LOGIN_PREFILL = {
  enabled: __DEV__ || isDevHubClient(),
  phone: '60637521',
  password: '009009009dm',
} as const;

export function getDevLoginPhoneInitial(): string {
  return DEV_LOGIN_PREFILL.enabled ? DEV_LOGIN_PREFILL.phone : '';
}

export function getDevLoginPasswordInitial(): string {
  return DEV_LOGIN_PREFILL.enabled ? DEV_LOGIN_PREFILL.password : '';
}
